import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  handleNext,
  handlePrev,
  setActiveTab,
} from "../../../redux/features/questions/questionSlice";
import { ReactComponent as NextIcon } from "../../../images/next.svg";
import { ReactComponent as PrevIcon } from "../../../images/prev.svg";
import { submitTheory } from "../../../redux/activityAsyncAction";

function PaginateBox() {
  const { list, currentIndex, activeTab } = useSelector(
    (state) => state.questions
  );
  const dispatch = useDispatch();

  return (
    <div className="w-90 justify-content-center align-self-center d-flex">
      <button
        className=" btn navigation-btn mx-2"
        onClick={() => {
          const nextQuestion = list[currentIndex - 1];
          if (nextQuestion.type === "theory" && !(activeTab === "theory")) {
            dispatch(setActiveTab("theory"));
          }
          if (
            nextQuestion.type === "multichoice" &&
            !(activeTab === "multichoice")
          ) {
            dispatch(setActiveTab("multichoice"));
          }
          dispatch(submitTheory(currentIndex));
          dispatch(handlePrev());
        }}
        disabled={currentIndex === 0}
      >
        <NextIcon style={{ marginLeft: "8px", marginRight: "4px" }} />
        Prev
      </button>
      <button
        className=" btn navigation-btn mx-2"
        onClick={() => {
          const nextQuestion = list[currentIndex + 1];
          if (nextQuestion.type === "theory" && !(activeTab === "theory")) {
            dispatch(setActiveTab("theory"));
          }
          if (
            nextQuestion.type === "multichoice" &&
            !(activeTab === "multichoice")
          ) {
            dispatch(setActiveTab("multichoice"));
          }
          dispatch(submitTheory(currentIndex));
          dispatch(handleNext());
        }}
        disabled={currentIndex === list.length - 1}
      >
        Next
        <PrevIcon style={{ marginLeft: "8px", marginRight: "4px" }} />
      </button>
    </div>
  );
}

export default PaginateBox;
